import React, { memo } from 'react';

const QuoteError = ({ quoteResponse }) => {
  const {
    quote: { errors },
  } = quoteResponse;

  const errorMessage = errors?.message;

  return (
    <div className="fees-container quote-error-container">
      <p className="error-message">{errorMessage}</p>
    </div>
  );
};

export default memo(QuoteError);
